export interface CustomerAccessRow {
  id: string;
  email: string;
  system: string;
  type: string;
}

export interface CustomerChargeRow {
  id: string;
  description: string;
  value: string;
  dueDate: string;
  status: string;
}

export function recordBelongsToCustomer(record: any, customerId: string): boolean {
  if (!customerId || !record) return false;
  const references = [
    record.customerId,
    record.customer?.id,
    record.customers?.id,
    ...(Array.isArray(record.customers)
      ? record.customers.map((item: any) => item?.id ?? item)
      : []),
  ].filter((value) => value != null && value !== '');

  if (!references.length) return true;
  return references.some((value) => String(value) === String(customerId));
}

export function toCustomerAccessRow(item: any): CustomerAccessRow {
  const system = item?.system;
  return {
    id: item?.id,
    email: item?.email || '-',
    system: typeof system === 'string' ? system : system?.name || '-',
    type: item?.fileType || item?.type || '-',
  };
}

export function toCustomerChargeRow(item: any): CustomerChargeRow {
  const amount = item?.value ?? item?.amount ?? item?.total;
  return {
    id: item?.id,
    description: item?.description || item?.title || item?.name || 'Cobrança',
    value: formatChargeValue(amount),
    dueDate: formatChargeDate(item?.dueDate || item?.expiresAt),
    status: item?.status || '-',
  };
}

function formatChargeValue(value: unknown): string {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '-';
  return amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function formatChargeDate(value: unknown): string {
  if (value == null || value === '') return '-';
  if (typeof value === 'string' && /^\d{2}\/\d{2}\/\d{4}/.test(value)) {
    return value.slice(0, 10);
  }
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    const [year, month, day] = value.slice(0, 10).split('-');
    return `${day}/${month}/${year}`;
  }
  const date = new Date(value as string);
  if (Number.isNaN(date.getTime())) return '-';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${day}/${month}/${date.getFullYear()}`;
}
